// let element = component();
// document.body.appendChild(element);
// import {ReactDOM} from 'react';
// import skeleton_css from './style/Skeleton-2.0.4/css/skeleton.css'
import grid4_css from './style/grid4.css'
import grid3_css from './style/grid3.css'
import grid2_css from './style/grid2.css'
import grid1_css from './style/grid1.css'
import video_css from './style/video.css'
import buttons_css from './style/buttons.css'
import main_css from './style/main.css'
import switch_css from './style/switch_board.css'
import actuators_css from './style/actuators.css'
import icomm_css from './style/intercom.css'
import activity_css from './style/activity.css'
import activity_smotion_css from './style/activity-smotion.css'
import '../node_modules/@fortawesome/fontawesome-free/css/all.css';


import React, { Component} from "react";
import ReactDOM from "react-dom"
import App from './js/components/container/App.jsx'
import uv4lClient from './js/uv4l.js';

const wrapper = document.getElementById('root');
ReactDOM.render(<App/>, wrapper);


